import _ from 'lodash';
import axios from 'axios';
import { flattenDeep } from 'lodash';
import { connect } from 'react-redux';
import React, { Fragment, useEffect, useRef, useState } from 'react';
import FileBase64 from './Utils/FileUpload';
import Highlighter from 'react-highlight-words';
import { constant } from '../../../Utils/constants';
import localStorage from '../../../../../utils/localStorage';
import InputComponent from '../../../Widgets/InputComponent';
import StyledTable from "../../../../../commons/styles/table";

import { API_ASSET, API_HIERARCHYMODULE } from '../../../../../commons/api';
import themeSettings from '../../../../../commons/styles/themeSettings.json';
import { Drawer, Form, Tree, Input, message, Tabs, Tooltip, Select, Button } from 'antd';
import { DownOutlined, EditOutlined, PaperClipOutlined, SearchOutlined } from '@ant-design/icons';
import {
  AddItemDiv,
  HomeSubMenu
} from './CSS/style';
import {
  _getDeviceTypesList,
  _saveAssetData,
  _saveDeviceData,
  _updateAssetData,
  _updateDeviceData,
  getSitesList
} from './APICalls';
import { StyledHomepage } from '../../../../../commons/styles/layout';

const { TabPane } = Tabs;
const { Option } = Select;

const AssetDeviceComponent = (props) => {
  const [, setSelectedKeys] = useState([]);
  const [editPObject, setEditPObject] = useState({});
  const [visibleParent, setVisibleParent] = useState(false);
  const [fileDataChild, setFileDataChild] = useState([]);
  const [fileDataParent, setFileDataParent] = useState([]);

  const [formObject, setFormObject] = useState({});
  const [treeData, setTreeData] = useState({});
  const [expandedKeys, setExpandedKeys] = useState([]);
  const [visibleAsset, setVisibleAsset] = useState(false);
  const [assetEditObj, setAssetEditObj] = useState({});
  const [visibleDevice, setVisibleDevice] = useState(false);
  const [deviceEditObj, setDeviceEditObj] = useState({});
  const [searchValue, setSearchValue] = useState('');
  const [, setSiteList] = useState([]);
  const [deviceTypeList, setDeviceTypeList] = useState([]);
  const assetPRef = useRef();
  const assetRef = useRef();
  const deviceRef = useRef();
  const searchInput = useRef(null);


  useEffect(() => {
    const fetchData = async () => {
      const siteList = await getSitesList();
      const deviceTypeList = await _getDeviceTypesList();
      getHierarchyLevels();
      setSiteList(siteList);
      setDeviceTypeList(deviceTypeList);
    };
    fetchData();
  }, []);

  const getHierarchyLevels = () => {
    const { defaultHiearchy } = props;
    const payload = {
      HierarchyCode: defaultHiearchy && defaultHiearchy.HierarchyCode ? defaultHiearchy.HierarchyCode : '',
      Type: 'Asset',
      HierarchyType: 'AMM'
    };
    const siteId = localStorage.get('currentSite');
    const accessToken = localStorage.get('accessToken');
    const headers = {
      method: 'GET',
      url: `${API_HIERARCHYMODULE.GetHierarchyLevels}?SiteId=${siteId}&HierarchyCode=${payload.HierarchyCode}&Type=${payload.Type}&HierarchyType=${payload.HierarchyType}`,
      headers: {
        Authorization: `Bearer ${accessToken}`
      }
    };
    axios(headers)
      .then(({ data }) => {
        if (Array.isArray(data)) {
          expandAll(data);
          setTreeData(data);
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const expandAll = async (treeData) => {
    const expandedKeys = getAllKeys(treeData);
    setExpandedKeys(expandedKeys);
  };

  const getAllKeys = (data) => {
    const nestedKeys = data.map((node) => {
      let childKeys = [];
      if (node.children) {
        childKeys = getAllKeys(node.children);
      }
      return [childKeys, node.key];
    });
    return flattenDeep(nestedKeys);
  };

  const getColumnSearchProps = (dataIndex) => ({
    filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
      <div style={{ padding: 8 }}>
        <Input
          ref={searchInput}
          placeholder={translation('Search')}
          value={selectedKeys[0]}
          onChange={(e) => {
            setSelectedKeys(e.target.value ? [e.target.value] : []);
          }}
          onPressEnter={() => handleSearch(selectedKeys, confirm, dataIndex)}
          style={{ width: 188, marginBottom: 8, display: 'block' }}
        />
        <Button

          onClick={() => handleSearch(selectedKeys, confirm, dataIndex)}
          icon={<SearchOutlined />}

          style={{ width: 90, marginRight: 8 }}
        >
          {translation(constant.search)}
        </Button>
        <Button
          type='primary'
          danger
          onClick={() => handleReset(clearFilters, confirm)}

          style={{ width: 90 }}
        >
          {translation(`Reset`)}
        </Button>
      </div>
    ),
    filterIcon: (filtered) => (
      <SearchOutlined style={{ color: filtered ? '#1890ff' : undefined, }} />
    ),
    onFilter: (value, record) =>
      (record[dataIndex] ?? '').toString().toLowerCase().includes(value.toLowerCase()),
    onFilterDropdownVisibleChange: (visible) => {
      if (visible) {
        setTimeout(() => searchInput.current.select());
      }
    },
    render: (text) => {
      return (
        <Highlighter
          highlightStyle={{ backgroundColor: '#ffc069', padding: 0 }}
          searchWords={[searchValue]}
          autoEscape
          textToHighlight={text === null ? "" : text.toString()}
        />
      );
    }
  });

  const handleSearch = (selectedKeys, confirm) => {
    confirm();
    if (selectedKeys !== undefined) {
      setSearchValue(selectedKeys[0]);
    } else {
      setSearchValue('');
    }
  };

  const handleReset = (clearFilters, confirm) => {
    clearFilters();
    handleSearch([], confirm);
  };

  const getData = (Id, Type) => {
    const SiteId = localStorage.get('currentSite');
    const accessToken = localStorage.get('accessToken');
    const headers = {
      method: 'GET',
      url: `${API_ASSET.GETDEVICEANDSUBLOCATIONBYId}?Id=${Id}&Type=${Type}&SiteId=${SiteId}`,
      headers: {
        Authorization: `Bearer ${accessToken}`
      }
    };
    axios(headers)
      .then(({ data, message }) => {
        if (data) {
          setFormObject(data);
        } else {
          message.error(message);
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  // const getParent = (Name, ParentId, treeData) => {
  //   let firstLevelParent = {};
  //   let children = [];
  //   let secondLevelParent = [];
  //   for (let i = 0; i < treeData.length; i++) {
  //     const node = treeData[i];
  //     if (node.children) {
  //       if (node.children.some((item) => item.Id === ParentId)) {
  //         firstLevelParent = node;
  //         children = node.children;
  //         if (children) {
  //           for (let i = 0; i < children.length; i++) {
  //             const childNode = children[i];
  //             if (childNode.children && childNode.children.length > 0) {
  //               if (childNode.Id === ParentId) {
  //                 secondLevelParent = childNode;
  //               }
  //             }
  //           }
  //         }
  //         if (props.handleParentNode) {
  //           props.handleParentNode(firstLevelParent, secondLevelParent);
  //         }
  //       } else if (getParent(Name, ParentId, node.children)) {
  //         getParent(Name, ParentId, node.children);
  //       }
  //     }
  //   }
  //   return firstLevelParent;
  // };

  const renderTreeNodes = (data) => {

    return (
      data &&
      Array.isArray(data) &&
      data.map((item) => {
        const stringTitle =
          `${item.DisplayCode ? translation(item.DisplayCode) : ''}` +
          `(${item.Name ? translation(item.Name) : ''})`;

        const index = stringTitle.indexOf(searchValue);
        const beforeString = stringTitle.substring(0, index);
        const afterString = stringTitle.slice(index + searchValue && searchValue.length);

        if (item.children && item.children.length > 0) {
          return (
            <Tree.TreeNode
              title={
                index > -1 ? (
                  <span>
                    {beforeString}
                    <span style={{ color: props.customTree && props.customTree.searchHighlightText }}>{searchValue}</span>
                    {afterString}
                  </span>
                ) : (
                  <span>{stringTitle}</span>
                )
              }
              key={item.Id}
              dataRef={item}
            >
              {renderTreeNodes(item.children)}
            </Tree.TreeNode>
          );
        }
        return (
          <Tree.TreeNode
            key={item.key}
            title={
              <div>
                {index > -1 ? (
                  <span>
                    {beforeString}
                    <span style={{ color: props.customTree && props.customTree.searchHighlightText }}>{searchValue}</span>
                    {afterString}
                  </span>
                ) : (
                  <span>{stringTitle}</span>
                )}
              </div>
            }
            dataRef={item}
          />
        );
      })
    );
  };

  const translation = (keyword) => {
    const { translationCache } = props;
    return translationCache && translationCache[keyword] ? translationCache[keyword] : keyword;
  };

  const onChange = (e) => {
    const { value } = e.target;
    setSearchValue(value);
  };

  const openPDrawer = () => {
    setEditPObject({});
    setVisibleParent(true);
  };

  const onClose = (e) => {
    if (e.target.tagName === 'DIV') {
      e.preventDefault();
      message.error('Please Click On Cancel');
    } else {
      if (assetPRef.current) assetPRef.current.resetFields();
      setVisibleParent(false);
      setEditPObject({});
    }
  };

  const onCloseAsset = (e) => {
    if (e.target.tagName === 'DIV') {
      e.preventDefault();
      message.error('Please Click On Cancel');
    } else {
      if (assetRef.current) assetRef.current.resetFields();
      setVisibleAsset(false);
      setAssetEditObj({});
    }
  };

  const onCloseDevice = (e) => {
    if (e.target.tagName === 'DIV') {
      e.preventDefault();
      message.error('Please Click On Cancel');
    } else {
      if (deviceRef.current) deviceRef.current.resetFields();
      setVisibleDevice(false);
      setDeviceEditObj({});
    }
  };

  const savePAsset = async (e) => {
    e.preventDefault();
    // const { fileDataParent } = state;
    const siteId = localStorage.get('currentSite');
    assetPRef.current
      .validateFields()
      .then(async (values) => {
        values = {
          ...values,
          AssetType: 'location',
          ParentAsset: null,
          SiteId: siteId,
          ...(editPObject && editPObject['Attachments']
            ? { Attachments: editPObject['Attachments'] }
            : {})
        };
        const saveResponse = await _saveAssetData(values, fileDataParent);

        if (saveResponse && saveResponse.message) {
          message.success(`Parent Location Created successfully`);
          if (assetPRef.current) assetPRef.current.resetFields();
          setVisibleParent(false);
          setEditPObject({});
          getHierarchyLevels();
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const fileuploadParent = async (values, key, fileDataObject) => {
    let editPObject = assetPRef.current.getFieldsValue();
    if (editPObject[key]) {
      editPObject[key].push(...values);
    } else {
      editPObject[key] = values;
    }
    editPObject[key] =
      editPObject[key] &&
      editPObject[key].reduce((acc, current) => {
        const x = acc.find((item) => item.Name === current.Name);
        if (!x) {
          return acc.concat([current]);
        } else {
          return acc;
        }
      }, []);
    editPObject = {
      ...editPObject,
      [key]: editPObject[key]
    };
    let fileDataParent = new FormData();
    fileDataParent.append('files', fileDataObject);
    if (assetPRef.current) assetPRef.current.setFieldsValue(editPObject);
    setEditPObject(editPObject);
    setFileDataParent(fileDataParent);
  };

  const fileuploadChild = async (values, key, fileDataObject) => {
    let assetEditObj = assetRef.current.getFieldsValue();
    if (assetEditObj[key]) {
      assetEditObj[key].push(...values);
    } else {
      assetEditObj[key] = values;
    }
    assetEditObj[key] =
      assetEditObj[key] &&
      assetEditObj[key].reduce((acc, current) => {
        const x = acc.find((item) => item.Name === current.Name);
        if (!x) {
          return acc.concat([current]);
        } else {
          return acc;
        }
      }, []);
    assetEditObj = {
      ...assetEditObj,
      [key]: assetEditObj[key]
    };
    let fileDataChild = new FormData();
    fileDataChild.append('files', fileDataObject);
    if (assetRef.current) assetRef.current.setFieldsValue(assetEditObj);
    setAssetEditObj(assetEditObj);
    setFileDataChild(fileDataChild);
  };

  const saveAsset = async (e) => {
    e.preventDefault();
    // const { fileDataChild, formObject } = state;
    const SiteId = localStorage.get('currentSite');
    assetRef.current
      .validateFields()
      .then(async (values) => {
        delete values.Id;
        values = {
          ...values,
          AssetType: 'subLocation',
          ParentAsset: formObject && formObject.AssetCode ? formObject.AssetCode : '',

          SiteId
        };
        const saveResponse = await _saveAssetData(values, fileDataChild);
        if (saveResponse && saveResponse.message) {
          message.success(saveResponse.message);
          setVisibleAsset(false);
          setAssetEditObj({});
          if (assetRef.current) assetRef.current.resetFields();
          getData(formObject.Id, formObject.Type);
          getHierarchyLevels();
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const updateAsset = async (e) => {
    e.preventDefault();
    // const { formObject, fileDataChild, assetEditObj } = state;
    const SiteId = localStorage.get('currentSite');
    assetRef.current
      .validateFields()
      .then(async (values) => {
        values = {
          ...values,
          AssetType: 'subLocation',
          ParentAsset: formObject && formObject.AssetCode ? formObject.AssetCode : '',
          SiteId,
          AssetCode: assetEditObj.AssetCode
        };
        const updateResponse = await _updateAssetData(values, fileDataChild);
        if (updateResponse && updateResponse.message) {
          message.success(updateResponse.message);
          setVisibleAsset(false);
          setAssetEditObj({});
          if (assetRef.current) assetRef.current.resetFields();
          getData(formObject.Id, formObject.Type);
          getHierarchyLevels();
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const saveDevice = async (e) => {
    e.preventDefault();
    // const { formObject } = state;
    const SiteId = localStorage.get('currentSite');
    deviceRef.current &&
      deviceRef.current
        .validateFields()
        .then(async (values) => {
          delete values.Id;
          values = {
            ...values,
            EquipmentType: 'Parent',
            TimeSeries: false,
            Asset: formObject && formObject.AssetCode ? formObject.AssetCode : '',
            SiteId
          };
          const saveResponse = await _saveDeviceData(values);
          if (saveResponse && saveResponse.message) {
            message.success(saveResponse.message);
            setVisibleDevice(false);
            setDeviceEditObj({});
            if (deviceRef.current) deviceRef.current.resetFields();
            getData(formObject.Id, formObject.Type);
            getHierarchyLevels();
          }
        })
        .catch((error) => {
          console.log(error);
        });
  };

  const updateDevice = async (e) => {
    e.preventDefault();
    // const { formObject, deviceEditObj } = state;
    const SiteId = localStorage.get('currentSite');
    deviceRef.current
      .validateFields()
      .then(async (values) => {
        values = {
          ...values,
          TimeSeries: false,
          Asset: formObject && formObject.AssetCode ? formObject.AssetCode : '',
          SiteId,
          DeviceCode: deviceEditObj.DeviceCode
        };
        const updateResponse = await _updateDeviceData(values);
        if (updateResponse && updateResponse.Id) {
          message.success('Successfully Updated');
          setVisibleDevice(false);
          setDeviceEditObj({});
          if (deviceRef.current) deviceRef.current.resetFields();
          getData(formObject.Id, formObject.Type);
          getHierarchyLevels();
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const onExpand = (expandedKeys) => {
    setExpandedKeys(expandedKeys);
  };

  const onSelect = (selectedKeys, info) => {
    getData(
      info &&
        info['selectedNodes'] &&
        info['selectedNodes'][0] &&
        info['selectedNodes'][0]['dataRef'] &&
        info['selectedNodes'][0]['dataRef']['Id']
        ? info['selectedNodes'][0]['dataRef']['Id']
        : '',
      info &&
        info['selectedNodes'] &&
        info['selectedNodes'][0] &&
        info['selectedNodes'][0]['dataRef'] &&
        info['selectedNodes'][0]['dataRef']['Type']
        ? info['selectedNodes'][0]['dataRef']['Type']
        : ''
    );
    setSelectedKeys(selectedKeys);
  };

  return (
    <Fragment>
      <div style={{ display: 'flex', flexWrap: 'wrap' }}>
        <div
          style={{
            width: '100%',
            flex: '25%',
            overflowY: 'auto',
            height: window.innerHeight - 87,
            background: props && props.themeValue && props.themeValue.token && props.themeValue.token.colorBgBase
          }}
        >
          <Input
            style={{ width: '98%', margin: "5px" }}
            placeholder={translation("Search here")}
            prefix={<SearchOutlined />}
            onChange={onChange}
          />

          <Tree
            onSelect={onSelect}
            onExpand={onExpand}
            expandedKeys={expandedKeys}
            showLine
            defaultExpandAll={true}
            switcherIcon={<DownOutlined />}
          >
            {renderTreeNodes(treeData)}
          </Tree>
        </div>

        <div
          style={{
            flex: '74%',
            paddingLeft: '17px'
          }}
        >
          <StyledHomepage>
            <AddItemDiv>
              <div></div>
              <div>
                <Button type="primary" onClick={openPDrawer}>
                  {translation(`Add Parent Location`)}
                </Button>
              </div>
            </AddItemDiv>

            <Drawer
              title={translation(`Add Parent Location`)}
              placement="right"
              width={400}
              closable
              onClose={onClose}
              open={visibleParent}
              footer={
                <div style={{ display: "flex", flexDirection: "row-reverse" }}>
                  <Button type="primary" onClick={savePAsset}>
                    {translation(`Create`)}
                  </Button>
                  <Button onClick={onClose} style={{ marginRight: 8 }}>
                    {translation('Cancel')}
                  </Button>
                </div>
              }
            >
              <Form
                layout="vertical"
                ref={assetPRef}
                name="user_form1"
                initialValues={editPObject || {}}
              >
                <Form.Item
                  label={translation(`Location Name`)}
                  name={'AssetCode'}
                  style={{ width: 300 }}
                  rules={[
                    {
                      required: true,
                      message: translation(`Input Location Name`)
                    },
                    {
                      message: 'field does not accept special characters'
                    }
                  ]}
                >
                  <Input placeholder={translation(`Input Location Name`)} />
                </Form.Item>
                <Form.Item
                  label={translation(`Location Description`)}
                  name={'Name'}
                  style={{ width: 300 }}
                  rules={[
                    {
                      required: true,
                      message: translation(`Input Location Description`)
                    },
                    {
                      message: 'field does not accept special characters'
                    }
                  ]}
                >
                  <Input placeholder={translation(`Input Location Description`)} />
                </Form.Item>
                <Form.Item
                  style={{ flex: '50%' }}
                  name={'Attachments'}
                  label={
                    <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                      <span>
                        {translation(constant.attachments)}
                        <PaperClipOutlined className="plusCircleOutlined" />
                      </span>
                    </div>
                  }
                >
                  <FileBase64
                    style={{ width: 300 }}
                    Attachments={editPObject.Attachments}
                    fileUpload={fileuploadParent}
                  />
                </Form.Item>
              </Form>

            </Drawer>

            <Form
              name="Item"
              theme={themeSettings}
              initialValues={formObject}
              layout="horizontal"
              labelCol={{ flex: '130px', marginTop: '20px' }}
              labelAlign="right"
              labelWrap
            >
              <div style={{ display: 'flex', flexWrap: 'wrap' }}>
                <Form.Item
                  style={{ width: '50%', flex: '50%' }}
                  label={translation(constant.Location)}
                >
                  <InputComponent
                    style={{ width: '90%' }}
                    value={formObject ? translation(formObject.DisplayCode) : ''}
                    disabled
                  />
                </Form.Item>

                <Form.Item
                  style={{ width: '50%', flex: '50%' }}
                  label={translation(constant.LocationDescription)}
                >
                  <InputComponent
                    value={formObject ? translation(formObject.Name) : ''}
                    style={{ width: '90%' }}
                    disabled
                  />
                </Form.Item>

                <Form.Item
                  style={{ width: '50%', flex: '50%' }}
                  label={translation(constant.ParentLocation)}
                >
                  <InputComponent
                    style={{ width: '90%' }}
                    value={
                      formObject && formObject.ParentDisplayCode
                        ? translation(formObject.ParentDisplayCode)
                        : ''
                    }
                    disabled
                  />

                </Form.Item>

                <Form.Item
                  style={{ width: '50%', flex: '50%' }}
                  label={translation(constant.ParentLocationDescription)}
                >
                  <InputComponent
                    value={
                      formObject && formObject.ParentLocationDescription
                        ? translation(formObject.ParentLocationDescription)
                        : ''
                    }
                    style={{ width: '90%' }}
                    disabled
                  />
                </Form.Item>
              </div>
            </Form>

            <Tabs
              tabPosition="top"
              type="card"
              style={{ marginTop: '20px' }}
            >
              <TabPane
                tab={
                  <HomeSubMenu>{translation('Child Locations')}</HomeSubMenu>
                }
                key={'childLocation'}
              >
                <AddItemDiv>
                  <div></div>
                  <div>
                    <Button
                      type="primary"
                      onClick={(e) => {
                        e.preventDefault();
                        setAssetEditObj({});
                        setVisibleAsset(true);
                        if (assetRef.current) assetRef.current.resetFields();
                      }}
                    >
                      {translation('Add Child Location')}
                    </Button>
                  </div>
                </AddItemDiv>
                <div>
                  <StyledTable size="small"
                    dataSource={
                      formObject &&
                        formObject.ChildrenLocations &&
                        Array.isArray(formObject.ChildrenLocations)
                        ? formObject.ChildrenLocations
                        : []
                    }
                    pagination={
                      formObject &&
                        formObject.ChildrenLocations &&
                        Array.isArray(formObject.ChildrenLocations) &&
                        formObject.ChildrenLocations.length > 10
                        ? {
                          pageSize: '10'
                        }
                        : false
                    }
                    columns={[
                      {
                        title: translation(`${_.startCase(_.toLower('Location'))} Name`),
                        dataIndex: 'DisplayCode',
                        key: 'DisplayCode',
                        ...getColumnSearchProps('DisplayCode')
                      },
                      {
                        title: translation(`${_.startCase(_.toLower('Location'))} Description`),
                        dataIndex: 'Name',
                        key: 'Name',
                        ...getColumnSearchProps('Name')
                      },
                      {
                        title: translation('Action'),
                        dataIndex: 'Action',
                        key: 'Action',
                        render: (text, row) => {
                          return {
                            children: (
                              <div>
                                <Button
                                  type='primary'
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    setAssetEditObj(row);
                                    setVisibleAsset(true);
                                    if (assetRef.current) assetRef.current.setFieldsValue(row);
                                  }}
                                >
                                  <Tooltip title={translation('Edit')}>
                                    <EditOutlined />
                                  </Tooltip>
                                </Button>
                              </div>
                            )
                          };
                        }
                      }
                    ]}
                  />
                  <Drawer
                    title={
                      !assetEditObj.Id
                        ? translation(`Create ${_.startCase(_.toLower('Location'))}`)
                        : translation(`Update ${_.startCase(_.toLower('Location'))}`)
                    }
                    placement="right"
                    width={400}
                    closable
                    onClose={onCloseAsset}
                    open={visibleAsset}
                    footer={
                      <div style={{ display: "flex", flexDirection: "row-reverse" }}>
                        {!assetEditObj.Id ? (
                          <Button type='primary' onClick={saveAsset}>
                            {translation(`Create Location`)}
                          </Button>
                        ) : (
                          <Button type='primary' onClick={updateAsset}>
                            {translation(`Update Location`)}
                          </Button>
                        )}
                        <Button onClick={onCloseAsset} style={{ marginRight: 8 }}>
                          {translation('Cancel')}
                        </Button>
                      </div>
                    }
                  >
                    <Form
                      layout="vertical"
                      ref={assetRef}
                      name="user_form"
                      initialValues={assetEditObj || {}}
                    >
                      <Form.Item
                        label={translation(`Location Name`)}
                        name={'DisplayCode'}
                        style={{ width: 300 }}
                        rules={[
                          {
                            required: true,
                            message: translation(`Input Location Name`)
                          },
                          {
                            message: translation('field does not accept special characters')
                          }
                        ]}
                      >
                        <Input
                          placeholder={translation(`Input Location Name`)}
                          disabled={assetEditObj && assetEditObj.Id ? true : false}
                        />
                      </Form.Item>
                      <Form.Item
                        label={translation(`Location Description`)}
                        name={'Name'}
                        style={{ width: 300 }}
                        rules={[
                          {
                            required: true,
                            message: translation(`Input Location Description`)
                          },
                          {
                            message: translation('field does not accept special characters')
                          }
                        ]}
                      >
                        <Input placeholder={translation(`Input Location Description`)} />
                      </Form.Item>
                      <Form.Item
                        style={{ flex: '50%' }}
                        name={'Attachments'}
                        label={
                          <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                            <span>
                              {translation(constant.attachments)}
                              <PaperClipOutlined className="plusCircleOutlined" />
                            </span>
                          </div>
                        }
                      >
                        <FileBase64
                          style={{ width: 300 }}
                          Attachments={assetEditObj.Attachments}
                          fileUpload={fileuploadChild}
                        />
                      </Form.Item>
                      <Form.Item
                        label="Id"
                        display="none"
                        name="Id"
                        hidden={true}
                        initialValue={assetEditObj.Id || ''}
                      >
                        <Input style={{ display: 'none' }} />
                      </Form.Item>
                    </Form>

                  </Drawer>
                </div>
              </TabPane>
              <TabPane
                tab={<HomeSubMenu>{translation('Equipments')}</HomeSubMenu>}
                key={'Equipments'}
              >
                <div>
                  <AddItemDiv>
                    <div></div>
                    <Button
                      type='primary'
                      onClick={(e) => {
                        e.preventDefault();
                        setDeviceEditObj({});
                        setVisibleDevice(true);
                        if (deviceRef.current) deviceRef.current.resetFields();
                      }}
                    >
                      {translation('Add Equipment')}
                    </Button>
                  </AddItemDiv>
                </div>
                <div>
                  <StyledTable size="small"
                    columns={[
                      {
                        title: translation(`${_.startCase(_.toLower('Equipment'))} Name`),
                        dataIndex: 'DisplayCode',
                        key: 'DisplayCode',
                        ...getColumnSearchProps('DisplayCode')
                      },
                      {
                        title: translation(`${_.startCase(_.toLower('Equipment'))} Description`),
                        dataIndex: 'Name',
                        key: 'Name',
                        ...getColumnSearchProps('Name')
                      },
                      {
                        title: translation('Action'),
                        dataIndex: 'Action',
                        key: 'Action',
                        render: (text, row) => {
                          return {
                            children: (
                              <div>
                                <Button
                                  type='primary'
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    setDeviceEditObj(row);
                                    setVisibleDevice(true);
                                    if (deviceRef.current) deviceRef.current.setFieldsValue(row);
                                  }}
                                >
                                  <Tooltip title="Edit">
                                    <EditOutlined />
                                  </Tooltip>
                                </Button>
                              </div>
                            )
                          };
                        }
                      }
                    ]}
                    dataSource={
                      formObject && formObject.Equipments && Array.isArray(formObject.Equipments)
                        ? formObject.Equipments
                        : []
                    }

                    pagination={
                      formObject &&
                        formObject.Equipments &&
                        Array.isArray(formObject.Equipments) &&
                        formObject.Equipments.length > 10
                        ? {
                          pageSize: '10'
                        }
                        : false
                    }
                  />
                  <Drawer
                    title={
                      !deviceEditObj.Id
                        ? translation(`Create Equipment`)
                        : translation(`Update Equipment`)
                    }
                    placement="right"
                    width={400}
                    closable
                    onClose={onCloseDevice}
                    open={visibleDevice}
                    footer={
                      <div style={{ display: "flex", flexDirection: "row-reverse" }}>
                        <div >
                          {!deviceEditObj.Id ? (
                            <Button type='primary' onClick={saveDevice}>
                              {translation(`Create Equipment`)}
                            </Button>
                          ) : (
                            <Button type='primary' onClick={updateDevice}>
                              {translation(`Update Equipment`)}
                            </Button>
                          )}
                        </div>
                        <Button style={{ marginRight: 8 }} onClick={onCloseDevice}>
                          {translation(`Cancel`)}
                        </Button>
                      </div>
                    }
                  >
                    <Form
                      layout="vertical"
                      ref={deviceRef}
                      name="user_form"
                      initialValues={deviceEditObj || {}}
                    >
                      <Form.Item
                        label={translation(`Equipment Name`)}
                        name={'DisplayCode'}
                        style={{ width: 300 }}
                        rules={[
                          {
                            required: true,
                            message: translation(`Input Equipment Name`)
                          },
                          {
                            message: 'field does not accept special characters'
                          }
                        ]}
                      >
                        <Input
                          placeholder={translation(`Input Equipment Name`)}
                          disabled={deviceEditObj && deviceEditObj.Id ? true : false}
                        />
                      </Form.Item>
                      <Form.Item
                        label={translation(`Equipment Description`)}
                        name={'Name'}
                        style={{ width: 300 }}
                        rules={[
                          {
                            required: true,
                            message: translation(`Input Equipment Description`)
                          },
                          {
                            message: 'field does not accept special characters'
                          }
                        ]}
                      >
                        <Input placeholder={translation(`Input Equipment Description`)} />
                        {/* </Form> */}
                      </Form.Item>
                      <Form.Item
                        label={translation(`Equipment Category`)}
                        name={'DeviceType'}
                        style={{ width: 300 }}
                        placeholder={translation(`Equipment Category`)}
                        rules={[
                          {
                            required: true,
                            message: translation(`Equipment Category`)
                          }
                        ]}
                      >
                        <Select
                          placeholder={translation('Select Equipment Category')}
                          defaultValue={deviceEditObj ? deviceEditObj.DeviceType : ''}
                          style={{ width: 300 }}
                        // onChange={handleChange}
                        >
                          {deviceTypeList
                            ? deviceTypeList.map((deviceType, index) => (
                              <Option key={index} value={deviceType.AliasCode}>
                                {deviceType.Name}
                              </Option>
                            ))
                            : null}
                        </Select>
                      </Form.Item>
                      <Form.Item
                        style={{
                          width: '100%',
                          flex: '50%'
                        }}
                        label={translation(constant.EquipmentDisplayCode)}
                        name="DisplayCode"
                        rules={[{ required: true }]}
                      >
                        <InputComponent
                          style={{ width: 300 }}
                          placeholder={translation(constant.InputDisplayCode)}
                        />
                      </Form.Item>
                      <Form.Item
                        label="Id"
                        display="none"
                        name="Id"
                        hidden={true}
                        initialValue={deviceEditObj.Id || ''}
                      >
                        <Input style={{ display: 'none' }} />
                      </Form.Item>
                      <Form.Item name="EquipmentType"></Form.Item>
                    </Form>


                  </Drawer>
                </div>
              </TabPane>
            </Tabs>
          </StyledHomepage>
        </div>
      </div>
    </Fragment>
  );
};

const mapStateToProps = (state) => {
  return {
    themeValue: state.ThemeReducer,
    translationCache: state.TranslationReducer.translationCache,
    defaultHiearchy: state.LayoutReducer.DefaultHierarchy,
    customTree: state.ThemeReducer.customComponent?.Tree
  };
};

export default connect(mapStateToProps)(AssetDeviceComponent);